import $ from 'jquery';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.second-button').on('click', function () {
      $('.burger-menu').toggleClass('open');
    });
  },
};
